import {Circle, LatLng, latLng, MapOptions, Marker, Polygon, tileLayer} from "leaflet";

export class MarkerBase {
  initialized: boolean = false;
  options: MapOptions = {
    layers: [tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      opacity: 0.7,
      maxZoom: 19,
      detectRetina: true,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    })],
    zoom: 5,
    center: latLng(0, 0)
  };
  markers: Marker<any>[] | Circle[] | Polygon[] = [];

  center: LatLng = latLng(51.032267969831, 13.706916853300902)
  zoom: number = 5;

  print() {
  }

  updateMarkers(devices: any) {
  }
}
